module.exports = __webpack_public_path__ + "static/media/image13.3ed4f145.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SketchBook/image13.jpg
// module id = 1085
// module chunks = 0